import { Component, OnInit, Input } from '@angular/core';
import {ISearchObj} from '@models/search.interface';
import {environment} from '@env/environment';
import { maxYear } from "@services/common";
import {SearchService} from '@services/search.service';
import { Table } from 'primeng/table';
import { Reports } from '../../services/reports';

@Component({
  selector: 'app-search-results',
  templateUrl: './search-results.component.html',
  styleUrls: ['./search-results.component.scss']
})
export class SearchResultsComponent implements OnInit {

  tableRows: number = 10;
  resultObject: ISearchObj;
  environment = environment;
  maxYear: number;
  @Input() exportDisabled: boolean = true;

  constructor(private searchSvc: SearchService, private _Reports: Reports) { }

  ngOnInit() {
    this.maxYear = maxYear;
    this.searchSvc.searchResults.subscribe({
      next:(newVals: ISearchObj) => {
        this.resultObject = newVals;
      }
    });
  }

  /* Move from main-search.component.ts */
  /* Handles the click of the CSV button*/
  makeCSV(dataTable?: Table) {
this.searchSvc.LogSearchQuery();

    let exportRows = [];

    let fieldRef = this._Reports.activeRpt.fields.sort((a: any, b: any) => {
      return (Number)(a.order > b.order) - (Number)(a.order < b.order);
    });
    let exportColumns = fieldRef.map((col: any) => {
      return col.label;
    });
    exportRows.push(exportColumns);
    exportColumns = [];
    if (dataTable.filteredValue && dataTable.filteredValue.length > 0) {
      dataTable.filteredValue.map(row => {
        let tmpRow = [];
        fieldRef.map((fieldDef: any) => {
          tmpRow.push("\"" + row[fieldDef.sortName] + "\"");
        });
        exportRows.push(tmpRow);
        tmpRow = [];
      });
    } else {
      this.resultObject.rows.map(row => {
        // console.log(JSON.stringify(row));
        let tmpRow = [];
        fieldRef.map((fieldDef: any) => {
          // if (fieldDef.sortName === 'state_parcel_number') {
            //*************************************************** */
            // need to make sure it is 12 characters always
            //*****************************************************/
          //   row[fieldDef.sortName] = row[fieldDef.sortName].replace(/(\d{4})(\d{4})(\d{4})/, "$1-$2-$3");
            // row[fieldDef.sortName] = "'" + row[fieldDef.sortName]            
          // }
          tmpRow.push("\"" + row[fieldDef.sortName] + "\"");
        });
        // console.log(tmpRow);
        exportRows.push(tmpRow);
        // console.log(JSON.stringify(exportRows));
        tmpRow = [];
      });
    }

    let fileTitle = this._Reports.activeRpt.key;
    let exportedFileName = fileTitle + ".csv" || "export.csv";

    let blob = new Blob([exportRows.join("\n")], {type:"text/csv;charset=utf-8;"});
    /*let _size = (blob.size / 1000000);
    console.log("***********************************");
    console.log("**  Blob Size: " + _size + "mb");
    console.log("***********************************");*/
    if (navigator.msSaveBlob) { // IE 10+
      navigator.msSaveBlob(blob, exportedFileName);
    } else {
      let link = document.createElement("a");
      if (link.download !== undefined) { // feature detection
        // Browsers that support HTML5 download attribute
        let url = URL.createObjectURL(blob);
        link.setAttribute("href", url);
        link.setAttribute("download", exportedFileName);
        link.style.visibility = "hidden";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    }
  }  
}
